import { render, staticRenderFns } from "./DockedFormFooter.vue?vue&type=template&id=2b795c3a&"
import script from "./DockedFormFooter.vue?vue&type=script&lang=ts&"
export * from "./DockedFormFooter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports